import { reactive, toRefs, provide, inject } from "@vue/composition-api";
import ApiContract from '@/api/contract/contract'
import { $t } from "@/i18n";
import axios from "axios";

export const state = reactive({
    contracts: [],
    contractTemplates: []
});

export const actions = {
    fetchClientContracts(params) {
        return new Promise(function (resolve, reject) {
            axios
                .get("/contracts/", { params })
                .then(resp => {
                    state.contracts = resp.data.contracts

                    resolve(resp.data)
                })
                .catch(ex => reject(ex));
        });
    },
    fetchContractTemplates(params) {
        return new Promise(function (resolve, reject) {
            axios
                .get("/contracts/templates/", { params })
                .then(resp => {
                    state.contractTemplates = resp.data

                    resolve(resp.data)
                })
                .catch(ex => reject(ex));
        });
    },

    /*
    Finishes replaced contracts and adds new
     */
    async replaceContractTemplateToClients(payload){
        try {
            let { data } = await axios.post("/contract_templates/replace_template/", payload)
            return data
        } catch (err){
            throw err.response.data
        }
    },
    async replaceExistingContractsWithTemplate(payload){
        try {
            let { data } = await axios.post("/contract_templates/replace_all_contracts/", payload)
            return data
        } catch (err){
            throw err.response.data
        }
    },
    async replaceQuarterlyContractsWithTemplate(payload){
        try {
            let { data } = await axios.post("/contract_templates/replace_quarterly_contracts/", payload)
            return data
        } catch (err){
            throw err.response.data
        }
    },
    async replaceMonthlyContractsWithTemplate(payload){
        try {
            let { data } = await axios.post("/contract_templates/replace_monthly_contracts/", payload)
            return data
        } catch (err){
            throw err.response.data
        }
    },
    async replaceYearlyContractsWithTemplate(payload){
        try {
            let { data } = await axios.post("/contract_templates/replace_yearly_contracts/", payload)
            return data
        } catch (err){
            throw err.response.data
        }
    },

    /*
    Append rows to existing
     */
    async appendContractTemplateToClients(payload){
        try {
            let { data } = await axios.post("/contract_templates/append_template/", payload)
            return data
        } catch (err){
            throw err.response.data
        }
    },
    async appendExistingContractsWithTemplate(payload){
        try {
            let { data } = await axios.post("/contract_templates/append_all_contracts/", payload)
            return data
        } catch (err){
            throw err.response.data
        }
    },
    async appendQuarterlyContractsWithTemplate(payload){
        try {
            let { data } = await axios.post("/contract_templates/append_quarterly_contracts/", payload)
            return data
        } catch (err){
            throw err.response.data
        }
    },
    async appendMonthlyContractsWithTemplate(payload){
        try {
            let { data } = await axios.post("/contract_templates/append_monthly_contracts/", payload)
            return data
        } catch (err){
            throw err.response.data
        }
    },
    async appendYearlyContractsWithTemplate(payload){
        try {
            let { data } = await axios.post("/contract_templates/append_yearly_contracts/", payload)
            return data
        } catch (err){
            throw err.response.data
        }
    },

    /*
    Add contract to client
     */
    async addContractTemplateToClients(payload){
        try {
            let { data } = await axios.post("/contract_templates/add_template/", payload)
            return data
        } catch (err){
            throw err.response.data
        }
    },
    async fetchContractTemplatesByClientId(client_ids) {
        let { data } = await axios.get("/contracts/templates_by_clients/", { params: { client_ids_list: client_ids }})
        return data
    },
    async saveContract(id, data) {
        return await axios.post(`/contracts/${id}`, data);
    },
    async saveContractTemplate(id, data) {
        return await axios.post(`/contracts/templates/${id}`, data);
    },
    async deleteContractTemplate(id) {
        await axios.delete(`/contracts/templates/${id}`);
    },

    async fetchClientBillingSettings(client_id, force_locale_code) {
        const { data } = await axios.get(`/client_billing_settings/${client_id}`, { params: { force_locale_code: force_locale_code }})
        return data
    },
    async editContractSettings(client_id) {
        const { data } = await axios.get(`/edit_contract_settings/${client_id}`)
        return data.edit_contract_settings
    },
    async saveContractSettings(client_id, settings) {
        await axios.put(`/edit_contract_settings/${client_id}`, { contract_settings: settings })
    },
    async deleteContract(id) {
        await ApiContract.deleteContract(id);
    }
};

export const getters = {
    getStatusColorMap: (status) => {
        let status_map = {
            "active": { text: $t("Active"), color: "green--text text--accent-4" },
            "pending": { text: $t("Pending"), color: "blue--text" },
            "finished": { text: $t("Finished"), color: "grey--text text--darken-1" },
        }

        return {
            color: status_map[status]["color"],
            text: $t(status_map[status]["text"])
        };
    },
};

export const key = Symbol("ContractModule");

export const provideContract = () => {
    provide(key, {
        ...toRefs(state),
        ...getters,
        ...actions
    });
};

export default () => inject(key);
